export function normalizarCpf(cpf?: string | number | null): string {
  if (cpf == null) {
    return '';
  }
  const apenasDigitos = String(cpf).replace(/\D/g, '');
  if (apenasDigitos.length === 0) {
    return '';
  }
  return apenasDigitos.padStart(11, '0');
}

export function cpfsIguais(cpfA?: string | number | null, cpfB?: string | number | null): boolean {
  const a = normalizarCpf(cpfA);
  const b = normalizarCpf(cpfB);
  return a.length > 0 && a === b;
}
